<label
    class="wrapper"
    [ngClass]="{ 'inline': inline, 'no-margin-bottom': contentType !== 'text', 'disabled': formControl.disabled }"
>
    <input
        class="input kk-visuallyhidden"
        [value]="value"
        [formControl]="formControl"
        type="radio"
        [name]="control | controlToKeyName"
        [checked]="checked"
    />
    <span
        [ngClass]="['element', inverted ? 'inverted' : '', isWhiteish ? 'white' : '']"
        [ngStyle]="{ color: color }"
    ></span>
    <span
        class="radio-content"
        [ngClass]="{
            'full-width': fullWidth,
            'display-label': contentType === 'text',
            'text': contentType === 'text',
            'kk-visuallyhidden': contentType === 'hidden'
        }"
    >
        <ng-content></ng-content>
    </span>
</label>
